export default {
  baseURLWD: process.env.REACT_APP_BASE_URL_WILL_DOTS,
  enableGTM: process.env.REACT_APP_ENABLE_GTM_TRACKING === 'true',
  GTM: process.env.REACT_APP_GTM_TRACKING_ID,
}
